export const CheckWithCirculeIcon = ({ activeColor }: { activeColor?: string }) => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Circle */}
            <circle
                cx="12"
                cy="12"
                r="9"
                stroke={activeColor}
                strokeWidth="2"
            />

            {/* Check */}
            <path
                d="M8 12L11 15L16 9"
                stroke={activeColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}